import AbsComponent from "../../common/components/AbsComponent";
import Templ from './CharChangeTempl';

class CharChange extends AbsComponent {
	constructor(_store = {}, _el = '') {
		super(_store, _el);
		window.characterChange = this.characterChange.bind(this);
	}

	characterChange() {
		if (this.store.getData('config').isLogin) {
			this.store.getData('CharacterList', {}, this.render.bind(this));
		}
	}

	render(_jsonData = {}) {
		$(this.el).html(Templ.getTempl(_jsonData));
		this.addEvents();
	}

	addEvents() {
		$(this.el + ' ul.bns-character-list li').on('click', (e) => {
			let data = $(e.currentTarget).data();
			this.store.changeBossChar(data.name, data.serverid, data.servertype, (e) => window.location.reload());
			return false;
		});
	}

} // end of class
export default CharChange;